import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<button\n  class=\"mobile-menu__toggle\"\n  type=\"button\"\n  {{on \"click\" this.onClick}}\n  ...attributes\n>\n  {{yield}}\n</button>")